export default "__VITE_ASSET__82217d20__"